import React, { FC } from 'react';
import { HormonePatternContent } from '../../../common/model/dto/hormone-pattern-content';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import OvListTable from '../atoms/OvListTable';
import OvListTableRow from '../atoms/OvListTableRow';
import OvListTableHeaderField from '../atoms/OvListTableHeaderField';
import OvHormonePatternContentListRow from './OvHormonePatternContentListRow';

interface OvHormonePatternContentsListProps {
  hormonePatternContents: HormonePatternContent[];
}

const OvHormonePatternContentsList: FC<OvHormonePatternContentsListProps> = ({
  hormonePatternContents,
}) => {
  const { t } = useTranslation();

  const headerNames = [
    {
      name: 'hormonePatternContents.headers.key',
    },
    {
      name: 'hormonePatternContents.headers.healthGoal',
    },
    {
      name: 'hormonePatternContents.headers.name',
    },
    {
      name: 'hormonePatternContents.headers.shortDescription',
    },
    {
      name: 'hormonePatternContents.headers.numberOfTimesDetected',
    },
    { name: 'common.action' },
  ];

  return (
    <WrapperBox>
      <OvListTable>
        <OvListTableRow>
          {headerNames.map(({ name }) => (
            <OvListTableHeaderField style={{ cursor: 'pointer' }}>
              {t(name)}
            </OvListTableHeaderField>
          ))}
        </OvListTableRow>

        {hormonePatternContents.map((hormonePatternContent) => (
          <OvListTableRow key={hormonePatternContent.id}>
            <OvHormonePatternContentListRow
              hormonePatternContent={hormonePatternContent}
            />
          </OvListTableRow>
        ))}
      </OvListTable>
    </WrapperBox>
  );
};

export default OvHormonePatternContentsList;

const WrapperBox = styled.div`
  padding: 1.5rem 1rem 1rem;
  overflow-x: auto;
`;
